export default function getPositionFromAngle(angle, rangeMax, isInBetweenPositions) {
  const unroundedPostion = angle / Math.PI / 2 * rangeMax;
  return isInBetweenPositions ? Math.round(unroundedPostion) : Math.floor(unroundedPostion);
}
